<template>
  <div
    class="modal fade"
    id="downloadAsModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="downloadAsModal"
    aria-hidden="true"
    style="background-color: rgba(0, 0, 0, 0.75);"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content rounded-0">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ $t('message.datasetDetails.datasets.modal.downloadAs') }} ...
          </h5>
          <button
            ref="modal-close-btn"
            type="button"
            id="modal-close-btn"
            data-dismiss="modal"
            class="close"
            aria-label="Close"
          >
            {{ $t('message.datasetDetails.datasets.modal.close') }}
            <span aria-hidden="true" class="close-icon rounded-circle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                height="8"
                id="Layer_1"
                style="enable-background: new 0 0 512 512"
                version="1.1"
                viewBox="0 0 512 512"
                width="8"
                xml:space="preserve"
              >
                <path
                  d="M437.5,386.6L306.8,256l130.7-130.6c14.1-14.2,14.1-37.1,0-51.2c-14.1-14.1-37-14.2-51.1,0L255.7,204.9L125,74.3
                  c-14.1-14.1-37-14.1-51.1,0c-14.1,14.2-14.1,37.1,0,51.2L204.6,256L73.9,386.6c-14.1,14.2-14.1,37.1,0,51.2
                  c14.1,14.1,37,14.1,51.1,0l130.7-130.6l130.7,130.6c14.1,14.1,37,14.1,51.1,0C451.6,423.7,451.6,400.8,437.5,386.6z"
                />
              </svg>
            </span>
          </button>
        </div>

        <div class="modal-body">
          <div class="align-items-center">
            <div class="ecl-form-group">
              <div class="ecl-select__container ecl-select__container--m">
                <select
                  v-model="selected"
                  @change="onChange"
                  class="ecl-select coursor-pointer"
                  id="select-default"
                  required
                >
                  <option value="" disabled hidden>
                    - {{ $t('message.datasetDetails.datasets.modal.selectFileFormat') }} -
                  </option>
                  <option
                    v-for="(option, index) in distributionDownloadAsOptions"
                    :key="index"
                    :value="option"
                    v-text="option.toUpperCase()"
                  ></option>
                  <div class="ecl-select__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xml:space="preserve"
                      width="16"
                      height="8"
                      shape-rendering="geometricPrecision"
                      text-rendering="geometricPrecision"
                      image-rendering="optimizeQuality"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      viewBox="0 0 512 298.04"
                    >
                      <path
                        fill="#ffffff"
                        fill-rule="nonzero"
                        d="M12.08 70.78c-16.17-16.24-16.09-42.54.15-58.7 16.25-16.17 42.54-16.09 58.71.15L256 197.76 441.06 12.23c16.17-16.24 42.46-16.32 58.71-.15 16.24 16.16 16.32 42.46.15 58.7L285.27 285.96c-16.24 16.17-42.54 16.09-58.7-.15L12.08 70.78z"
                      />
                    </svg>
                  </div>
                </select>
              </div>
            </div>

            <div v-if="error" class="error mt-4">
              <div class="error-body">
                <svg
                  width="40"
                  height="38"
                  viewBox="0 0 24 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="warning-icon"
                >
                  <path
                    d="M0 22L12 0L24 22H0ZM12 18.5263C12.3091 18.5263 12.5684 18.4152 12.7778 18.1928C12.9873 17.9705 13.0916 17.6957 13.0909 17.3684C13.0902 17.0411 12.9855 16.7663 12.7767 16.544C12.568 16.3217 12.3091 16.2105 12 16.2105C11.6909 16.2105 11.432 16.3217 11.2233 16.544C11.0145 16.7663 10.9098 17.0411 10.9091 17.3684C10.9084 17.6957 11.0131 17.9709 11.2233 18.194C11.4335 18.4171 11.6924 18.5279 12 18.5263ZM10.9091 15.0526H13.0909V9.26316H10.9091V15.0526Z"
                    fill="#FBC712"
                  />
                </svg>
                <span>
                  <span class="font-weight-bold ml-3">
                    {{ $t('message.datasetDetails.datasets.modal.fileConversionFail') }}
                  </span>
                  <br />
                  <span class="ml-3">
                    The target file contains an error, which prevents the conversion.
                  </span>
                  <div class="ml-3 details"><strong>Details</strong></div>
                  <p class="ml-3">{{ errorMsg }}</p>
                </span>
              </div>
            </div>

            <div v-if="converting">
              <div class="d-flex mt-4">
                <p class="m-0">
                  1 {{ $t('message.datasetDetails.datasets.modal.fileConversionTo') }}
                  <span class="font-weight-bold">{{ selected.toUpperCase() }}</span>
                </p>
                <i v-if="converted" class="success rounded-circle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="white"
                    class="bi bi-check"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1
                      1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                    />
                  </svg>
                </i>
              </div>

              <div class="d-flex mt-2">
                <p :class="{ active: converted }" class="m-0" style="color: #a8a8a8;">
                  2 {{ $t('message.datasetDetails.datasets.modal.downloading') }}
                </p>
                <i v-if="readyForDownload" class="success rounded-circle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="white"
                    class="bi bi-check"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1
                      1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                    />
                  </svg>
                </i>
              </div>

              <div class="w-100 text-right">{{ progress + '%' }}</div>
              <div class="progress mt-2">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: progress + '%' }"
                  :aria-valuenow="progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer justify-content-start">
          <button
            v-if="!done"
            @click="download"
            type="button"
            class="ecl-button ecl-button--secondary"
            :disabled="!selected || loadingTargets"
          >
            {{ downloadBtnText }}
          </button>
          <button
            v-else
            type="button"
            class="ecl-button ecl-button--secondary"
            data-dismiss="modal"
            aria-label="Close"
          >
            Done
          </button>

          <a
            v-if="error === true"
            class="ecl-button ecl-button--secondary ml-2"
            :href="downloadOrAccessUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Access source file
            <i class="material-icons align-middle smaller">open_in_new</i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { mapGetters } from 'vuex';

export default {
  name: 'ec-download-as-modal',
  data() {
    return {
      selected: '',
      loadingTargets: false,
      fetchedTargets: [],
      converting: false,
      converted: false,
      readyForDownload: false,
      error: false,
      done: false,
      progress: '0',
      downloadBtnText: 'Download',
      errorMsg: '',
    };
  },
  computed: {
    ...mapGetters('datasetDetails', ['getDistributionDownloadAsOptions', 'getDistributionDownloadAs']),
    distributionDownloadAsOptions() {
      if (this.fetchedTargets.length) {
        return this.fetchedTargets;
      }
      return this.getDistributionDownloadAsOptions || [];
    },
    downloadOrAccessUrl() {
      const selectedDistribution = this.getDistributionDownloadAs || {};
      const downloadUrls = selectedDistribution.downloadUrls || [];
      const accessUrls = selectedDistribution.accessUrl || [];
      if (downloadUrls.length) {
        return downloadUrls[0];
      }
      if (accessUrls.length) {
        return accessUrls[0];
      }
      return null;
    },
    currentSourceFormat() {
      return this.getDistributionDownloadAs?.format?.id || '';
    },
  },
  mounted() {
    this.onModalHide = () => this.resetState();
    this.onModalShow = () => this.prepareModal();
    $('#downloadAsModal').on('hide.bs.modal', this.onModalHide);
    $('#downloadAsModal').on('show.bs.modal', this.onModalShow);
  },
  beforeUnmount() {
    $('#downloadAsModal').off('hide.bs.modal', this.onModalHide);
    $('#downloadAsModal').off('show.bs.modal', this.onModalShow);
  },
  methods: {
    normalizeConvertEndpoint() {
      const configuredUrl = this.$env?.content?.datasetDetails?.downloadAs?.url || '';
      const clean = configuredUrl.replace(/\/+$/, '');
      if (!clean) {
        return '';
      }
      if (clean.includes('/v1/convert')) {
        return clean.endsWith('/v1/convert') ? `${clean}/` : clean;
      }
      return `${clean}/v1/convert/`;
    },
    normalizeFormat(format) {
      return String(format || '').trim().toLowerCase();
    },
    buildSourceConvertEndpoint(sourceFormat) {
      const endpoint = this.normalizeConvertEndpoint();
      if (!endpoint) {
        return '';
      }
      const source = this.normalizeFormat(sourceFormat);
      if (!source) {
        return endpoint;
      }
      return `${endpoint}${source}/`;
    },
    extractAllowedTargets(responseData) {
      const allowedTargets = responseData?.allowed_targets;
      if (!Array.isArray(allowedTargets)) {
        return [];
      }

      const unique = new Set();
      allowedTargets.forEach((target) => {
        const normalizedTarget = this.normalizeFormat(target);
        if (normalizedTarget) {
          unique.add(normalizedTarget);
        }
      });

      return Array.from(unique);
    },
    async prepareModal() {
      this.onChange();

      const sourceFormat = this.normalizeFormat(this.currentSourceFormat);
      if (!sourceFormat) {
        this.fetchedTargets = [];
        return;
      }

      const endpoint = this.buildSourceConvertEndpoint(sourceFormat);
      if (!endpoint) {
        this.error = true;
        this.errorMsg = 'Download-as conversion endpoint is not configured.';
        return;
      }

      this.loadingTargets = true;
      try {
        const response = await axios({
          method: 'get',
          url: endpoint,
          headers: {
            Accept: 'application/json',
          },
        });

        this.fetchedTargets = this.extractAllowedTargets(response.data);
        if (!this.fetchedTargets.length && !this.getDistributionDownloadAsOptions?.length) {
          this.error = true;
          this.errorMsg = `No target formats are available for source format "${sourceFormat}".`;
        }
      } catch (error) {
        this.fetchedTargets = [];
        const status = error?.response?.status;
        this.error = true;
        this.errorMsg = status
          ? `Could not load supported targets (HTTP ${status}).`
          : error?.message || 'Could not load supported targets.';
      } finally {
        this.loadingTargets = false;
      }
    },
    async requestConversion(payload) {
      const sourceFormat = this.normalizeFormat(payload?.source);
      const hasSourceFormat = Boolean(sourceFormat);
      const endpoint = hasSourceFormat
        ? this.buildSourceConvertEndpoint(sourceFormat)
        : this.normalizeConvertEndpoint();

      if (!endpoint) {
        throw new Error('Download-as conversion endpoint is not configured.');
      }

      return axios({
        method: 'post',
        url: endpoint,
        data: payload,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
      });
    },
    triggerBlobDownload(blobData) {
      const locale = this.$route?.query?.locale;
      const blobUrl = window.URL.createObjectURL(blobData);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.setAttribute('download', this.setFileName(locale));
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(blobUrl);
    },
    async download() {
      this.error = false;
      this.errorMsg = '';

      if (!this.selected || !this.downloadOrAccessUrl) {
        this.error = true;
        this.errorMsg = this.$t('message.datasetDetails.datasets.modal.fileTypeNotSupported');
        return;
      }

      const sourceFormat = this.normalizeFormat(this.currentSourceFormat);
      const targetFormat = this.normalizeFormat(this.selected);

      if (sourceFormat && sourceFormat === targetFormat) {
        window.open(this.downloadOrAccessUrl);
        this.done = true;
        return;
      }

      this.converting = true;
      this.downloadBtnText = 'Converting...';
      this.progress = '15';

      const payload = {
        url: this.downloadOrAccessUrl,
        target: targetFormat,
      };
      if (sourceFormat) {
        payload.source = sourceFormat;
      }

      try {
        const response = await this.requestConversion(payload);

        this.progress = '70';
        this.converted = true;
        this.downloadBtnText = 'Downloading...';
        this.progress = '100';
        this.readyForDownload = true;

        this.triggerBlobDownload(response.data);
        this.done = true;
      } catch (error) {
        if (error?.response?.data && typeof error.response.data.text === 'function') {
          this.errorMsg = await error.response.data.text();
        } else {
          const status = error?.response?.status;
          this.errorMsg = status
            ? `Conversion request failed (HTTP ${status}).`
            : error?.message || 'Conversion request failed.';
        }
        this.error = true;
        this.downloadBtnText = 'Retry';
        this.converting = false;
      }
    },
    onChange() {
      this.done = false;
      this.loadingTargets = false;
      this.converted = false;
      this.converting = false;
      this.readyForDownload = false;
      this.error = false;
      this.downloadBtnText = 'Download';
      this.errorMsg = '';
    },
    resetState() {
      this.selected = '';
      this.fetchedTargets = [];
      this.done = false;
      this.loadingTargets = false;
      this.converted = false;
      this.converting = false;
      this.readyForDownload = false;
      this.error = false;
      this.progress = '0';
      this.downloadBtnText = 'Download';
      this.errorMsg = '';
    },
    setFileName(locale) {
      const title = this.getDistributionDownloadAs?.title;
      if (!title) {
        return `file.${this.selected}`;
      }
      if (typeof title === 'string') {
        return `${title.split('.')[0]}.${this.selected}`;
      }
      if (locale && title[locale]) {
        return `${String(title[locale]).split('.')[0]}.${this.selected}`;
      }
      const firstValue = Object.values(title)[0];
      return `${String(firstValue).split('.')[0]}.${this.selected}`;
    },
  },
};
</script>

<style scoped lang="scss">
#downloadAsModal {
  .success {
    background: #00997A;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    height: 20px;
    width: 20px;
  }

  .modal-title {
    font-family: 'Arial';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    color: #000000;
  }

  .modal-content {
    border: 3px solid #0e47cb;
  }

  .modal-header {
    padding: 1.5rem 1.5rem 0rem 1.5rem;
    border-bottom: none;
  }

  .modal-body {
    padding: 1rem 1.5rem;
  }

  .modal-footer {
    border-top: none;
    padding: 1rem 1.5rem;
  }

  .close {
    font-size: 16px;
    color: #0e47cb;
    opacity: 1;
    padding: 0.5rem !important;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .close-icon {
    color: white;
    background: #0e47cb;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    float: right;
    margin-top: 3px;
    margin-left: 10px;
  }

  .active {
    color: #000000 !important;
  }

  .error {
    border: 2px solid #FBC712;
  }

  .error-body {
    padding: 1.8rem;
    display: flex;
  }

  .progress-bar {
    -webkit-transition: width 1s ease;
    -moz-transition: width 1s ease;
    -o-transition: width 1s ease;
    transition: width 1s ease;
  }

  .ecl-select {
    cursor: pointer;
  }

  .details {
    margin-top: 30px;
  }

  .warning-icon {
    margin-top: 5px;
    margin-right: 7px;
  }

  .smaller {
    font-size: 17px;
  }
}
</style>
